var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import EnvironmentService from "./EnvironmentService.js";
import parseURL from "url-parse";
import logger from "./logging/Logger.js";
import { TelemetryEventName } from "./MSALAuthService/TelemetryEventName.js";
import { isUsingWPSWorkspaceAndProxyEnabled, transformPathToId } from "../utils/WPSUtils.js";
const _WPSProxy = class _WPSProxy {
  static get instance() {
    this._instance = this._instance || new this();
    return this._instance;
  }
  getMiddleware() {
    return (settings, next) => {
      settings = this.applySettings(settings);
      return next(settings);
    };
  }
  applySettings(settings) {
    if (isUsingWPSWorkspaceAndProxyEnabled()) {
      const wpsStatus = EnvironmentService.getWpsStatus();
      const workspaceId = wpsStatus.wpsWorkspaceId;
      const experimentGroupNameOrID = wpsStatus.experimentGroup;
      const url = parseURL(settings.url);
      const targetUrl = (url == null ? void 0 : url.host) + (url == null ? void 0 : url.pathname) + (url == null ? void 0 : url.query);
      let experimentGroupSubPath = "";
      if (experimentGroupNameOrID) {
        let experimentGroupId = transformPathToId(experimentGroupNameOrID);
        experimentGroupSubPath = `/experimentation-group/${experimentGroupId}`;
      }
      settings.url = `${_WPSProxy._proxyUrl}/workspace/${workspaceId}${experimentGroupSubPath}/proxy/${targetUrl}`;
      logger.info(`${TelemetryEventName.WPS_Converter_Used_Proxy}`, {
        needRequestToProxy: wpsStatus == null ? void 0 : wpsStatus.needRequestToProxy,
        workspaceProxyEnabled: wpsStatus == null ? void 0 : wpsStatus.workspaceProxyEnabled,
        proxyUrl: settings.url,
        experimentGroupNameOrID
      });
      settings.headers = __spreadValues({ "x-ms-wps-workspaceid": workspaceId }, settings.headers);
    }
    return settings;
  }
};
__publicField(_WPSProxy, "_instance");
__publicField(_WPSProxy, "_proxyUrl", EnvironmentService.endpoints.wps.url);
let WPSProxy = _WPSProxy;
function WPSProxyConverter(enabled = true) {
  return (constructor) => {
    const nc = class extends constructor {
      constructor(...args) {
        super(...args);
        enabled && this.addMiddleWare(WPSProxy.instance.getMiddleware());
      }
    };
    return nc;
  };
}
export {
  WPSProxy,
  WPSProxyConverter
};
//# sourceMappingURL=WPSProxy.js.map
